module.exports = __webpack_public_path__ + "img/1.3ae2a3d6.png";